module.exports = __webpack_public_path__ + "img/87.aa27814a.jpg";